import React, { useEffect, useState } from "react";
import axios from "axios";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import SectionWrapper, {
    FormField,
    inputClassName,
} from "pages/createMission/components/SectionWrapper";
import AddressGeoApi from "components/AddressGeoApi/AddressGeoApi";
import Tooltip from "components/tooltips/Tooltips";
import { InformationIcon } from "assets/icons";

const LocationSalaryTemplate = () => {
    const { templateData, setTemplateData, companyData } = UseContext();
    const [address, setAddress] = useState(templateData.location || "");
    const [smic, setSmic] = useState("");

    useEffect(() => {
        ApiDataBase.getMinimumWage(
            (data) => {
                if (data?.hourly?.gross) setSmic(data.hourly.gross);
            },
            (err) => console.log(err)
        );
    }, []);

    useEffect(() => {
        if (
            address &&
            typeof address === "object" &&
            Object.keys(address).length > 0
        ) {
            setTemplateData((prev) => ({ ...prev, location: address }));
        }
    }, [address, setTemplateData]);

    useEffect(() => {
        if (
            (!templateData.location ||
                (typeof templateData.location === "object" &&
                    Object.keys(templateData.location).length === 0)) &&
            companyData.location
        ) {
            const abortController = new AbortController();
            axios({
                method: "get",
                url: `${process.env.REACT_APP_API_URL}address/${companyData.location}`,
                withCredentials: true,
                signal: abortController.signal,
            })
                .then((res) => {
                    if (res.data) setAddress(res.data);
                })
                .catch((err) => {
                    if (
                        err.code !== "ECONNABORTED" &&
                        err.code !== "ERR_CANCELED" &&
                        err.name !== "CanceledError"
                    )
                        console.log(err);
                });
            return () => abortController.abort();
        }
    }, [templateData.location, companyData.location]);

    const handleSalaryChange = (value) => {
        setTemplateData((prev) => ({ ...prev, salary: value }));
    };

    const toggleIndexed = () => {
        setTemplateData((prev) => {
            const next = !prev.isIndexedToMinimumWage;
            return {
                ...prev,
                isIndexedToMinimumWage: next,
                salary: next && smic ? smic : prev.salary,
            };
        });
    };

    return (
        <SectionWrapper
            title="Lieu & Rémunération"
            description="Adresse de la mission et taux horaire associés à cette fiche de poste."
        >
            <FormField label="Adresse">
                <AddressGeoApi
                    addressGeoValue={setAddress}
                    addressValue={address}
                    isAddressCompany={true}
                    page={"jobPostTemplate"}
                />
            </FormField>
            <FormField label="Taux horaire brut">
                <div className="relative">
                    <input
                        name="salary"
                        value={templateData.salary}
                        onChange={(e) => handleSalaryChange(e.target.value)}
                        className={`${inputClassName} pr-16`}
                        type="text"
                        placeholder="Ex: 12.50"
                        disabled={templateData.isIndexedToMinimumWage}
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                        <span className="ft-sm text-gray-500">€/heure</span>
                    </div>
                    <Tooltip
                        text={
                            "Quand la fiche est indexée au SMIC, le taux suit automatiquement la dernière valeur officielle."
                        }
                        placement="bottom"
                    >
                        <div className="absolute inset-y-0 right-16 z-20 flex items-center px-2 cursor-pointer">
                            <InformationIcon color={"#2CAFFF"} wh={15} />
                        </div>
                    </Tooltip>
                </div>
            </FormField>
            <div>
                <button
                    type="button"
                    onClick={toggleIndexed}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg border transition-all ${
                        templateData.isIndexedToMinimumWage
                            ? "border-yellow-500 bg-yellow-50 text-yellow-700"
                            : "border-gray-200 bg-white text-gray-600 hover:border-gray-300"
                    }`}
                >
                    <div
                        className={`w-4 h-4 rounded border flex items-center justify-center ${
                            templateData.isIndexedToMinimumWage
                                ? "border-yellow-500 bg-yellow-500"
                                : "border-gray-300 bg-white"
                        }`}
                    >
                        {templateData.isIndexedToMinimumWage && (
                            <svg
                                className="w-3 h-3 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={3}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        )}
                    </div>
                    <span className="ft-sm font-medium">
                        Indexer au SMIC ({smic ? `${smic}€/h` : "—"})
                    </span>
                </button>
            </div>
        </SectionWrapper>
    );
};

export default LocationSalaryTemplate;
